import _ from 'lodash';

import HttpService from '@/services/http';

export async function fetchConnectionOperationsList(route, params = {}) {
  const response = await HttpService.getInstance().request(`/${route}`, {
    method: 'get',
    params,
  });
  return mapConnectionOperationsResponse(response);
}

const normalizeScopes = (scopes) => {
  if (!Array.isArray(scopes)) return [];
  return scopes.map((scope) => String(scope || '').trim()).filter(Boolean);
};

export function mapConnectionOperationsResponse(res) {
  if (res == null) return [];

  const inner =
    _.isObject(res) && res.data !== undefined && !Array.isArray(res.data) ? res.data : res;
  const sharedBaseScopes = normalizeScopes(inner?.baseScopes ?? inner?.BaseScopes);

  if (Array.isArray(inner)) {
    return _.compact(
      _.map(inner, (op) => {
        const operation = op?.operation ?? op?.Operation ?? op?.value;
        if (operation == null || operation === '') return null;
        const display =
          op?.operationDisplay ??
          op?.OperationDisplay ??
          op?.name ??
          op?.text ??
          op?.label ??
          String(operation);
        const requiredScopes = normalizeScopes(op?.requiredScopes ?? op?.RequiredScopes);
        const baseScopes = normalizeScopes(op?.baseScopes ?? op?.BaseScopes ?? sharedBaseScopes);
        const rawWrite = op?.isWrite ?? op?.IsWrite;
        return {
          id: operation,
          value: operation,
          operation,
          operationDisplay: display,
          name: display,
          text: display,
          label: display,
          requiredScopes,
          baseScopes,
          ...(typeof rawWrite === 'boolean' && { isWrite: rawWrite }),
        };
      }),
    );
  }

  const ops = inner?.operations ?? inner?.Operations;
  if (!Array.isArray(ops)) return [];

  return _.compact(
    _.map(ops, (op) => {
      const operation = op?.operation ?? op?.Operation;
      if (operation == null || operation === '') return null;
      const display =
        op?.operationDisplay ?? op?.OperationDisplay ?? op?.label ?? op?.name ?? String(operation);
      const requiredScopes = normalizeScopes(op?.requiredScopes ?? op?.RequiredScopes);
      const baseScopes = normalizeScopes(op?.baseScopes ?? op?.BaseScopes ?? sharedBaseScopes);
      const rawWrite = op?.isWrite ?? op?.IsWrite;
      return {
        id: operation,
        value: operation,
        operation,
        operationDisplay: display,
        name: display,
        text: display,
        label: display,
        requiredScopes,
        baseScopes,
        ...(typeof rawWrite === 'boolean' && { isWrite: rawWrite }),
      };
    }),
  );
}
